import { Box } from "@mui/material";
import { TkRadioGroup } from "../../../components/atoms/TkRadioGroup";
import { TkGetCodeList } from "../../../utils/TkGetCode";
import { YesOrNoFlug } from "../../../assets/data/Constants";
import TkLabelText from "../../../components/atoms/TkLabelText";
import { useContext, useEffect, useState } from "react";
import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";
import { TkFormContext } from "../../../context/tkFormContext";

/**
 * 共済契約証書再交付申出有無/理由入力部品
 * @returns ReissueApplyInput
 */
const ReissueApplyInput = (props: any) => {
  const { onChange, res, disabled } = props;

  const { formContext, setFormContext } = useContext(TkFormContext);
  const [showText, setShowText] = useState(false);
  const [reissueApplyReasonText, setReissueApplyReasonText] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [formValues, setFormValues] = useState<any>({});

  const handleValidate = (
    radioState: boolean,
    reissueApplyReasonText: string
  ) => {
    if (radioState) {
      // ラジオボタン有
      if (!reissueApplyReasonText.match(/^([^ -~｡-ﾟ])*$/)) {
        setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0061E"));
        setFormContext({ preventSubmit: { againReissue: true } });
        return;
      }

      if (reissueApplyReasonText === "") {
        setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0043E"));
        setFormContext({ preventSubmit: { againReissue: true } });
        return;
      }
      setErrorMsg("");
    } else {
      // ラジオボタン無
      setErrorMsg("");
    }
  };

  const handleChangeRadio = (event: any) => {
    let value = event?.target?.value;
    if (formContext?.preventSubmit?.againReissue)
      setFormContext({ preventSubmit: { againReissue: false } });
    setShowText(value === YesOrNoFlug["有"]);
    handleValidate(
      value === YesOrNoFlug["有"] ? true : false,
      reissueApplyReasonText
    );

    const resObj = {
      reissueApplyFlg: value,
    };
    setFormValues(resObj);
  };

  const handleChangeText = (event: any) => {
    let value = event.target.value;
    handleValidate(showText, value);
    setReissueApplyReasonText(value);
    if (formContext?.preventSubmit?.againReissue)
      setFormContext({ preventSubmit: { againReissue: false } });

    const resObj = {
      ...formValues,
      reissueApplyReason: event.target.value,
    };
    setFormValues(resObj);
  };

  useEffect(() => {
    onChange && onChange(formValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues]);

  return (
    <Box>
      <TkRadioGroup
        radioPropsList={TkGetCodeList(YesOrNoFlug)}
        wantToSetValue={res?.reissueApplyFlg}
        onChange={handleChangeRadio}
        disabled={disabled}
      />
      {showText && (
        <TkLabelText
          className="reissueApplyReason"
          placeholder="再交付の理由"
          wantToSetValue={res?.reissueApplyReason}
          inputProps={{ maxLength: 100 }}
          onChange={handleChangeText}
          error={!!errorMsg}
          helperText={errorMsg}
          disabled={disabled}
        />
      )}
    </Box>
  );
};

export { ReissueApplyInput };
